import AppResource from '@milestoneslabs/milestones-js-engine/src/Data/AppResource'
import WorkspaceTypeAppResource from './WorkspaceTypeAppResource'
import OrganizationAppResource from './OrganizationAppResource'
import OrganizationMemberAppResource from './OrganizationMemberAppResource'
import WorkspaceAppResource from './WorkspaceAppResource'
import Engine from "@milestoneslabs/milestones-js-engine";

class PlaybookAppResource extends AppResource {
    /**
     * @returns {string}
     */
    appResourceType() {
        return 'Playbook'
    }

    /**
     * @returns {string}
     */
    appResourceApiPrefix() {
        return 'playbooks'
    }

    /**
     * @returns {*[]}
     */
    hidden() {
        return super.hidden().concat([
            'uuid',
            'deleted_at',
        ])
    }

    /**
     * @returns {*[]}
     */
    fillable() {
        return [
            'name',
            'settings',
            'status',
            'locked',
            'isSystem',
            'parentPlaybookUuid',
            'workspaceTypeUuid',
            'organization_uuid',
            'organizationUuid',
            'createdByOrganizationMemberUuid',
            'updatedByOrganizationMemberUuid',
            'parentPlaybook',
            'workspaceType',
            'organization',
            'createdByOrganizationMember',
            'updatedByOrganizationMember',
        ]
    }

    /**
     * @returns {*[]}
     */
    relationMap() {
        return {
            parentPlaybook: PlaybookAppResource,
            workspaceType: WorkspaceTypeAppResource,
            organization: OrganizationAppResource,
            workspaces: WorkspaceAppResource,
            createdByOrganizationMember: OrganizationMemberAppResource,
            updatedByOrganizationMember: OrganizationMemberAppResource,
        }
    }

    /**
     * @returns {*[]}
     */

    relationForeignKeys() {
        return {
            parentPlaybook: 'parent_playbook_uuid',
            workspaceType: 'workspace_type_uuid',
            organization: 'organization_uuid',
            createdByOrganizationMember: 'created_by_organization_member_uuid',
            updatedByOrganizationMember: 'updated_by_organization_member_uuid',
        }
    }

    /**
     * @returns {*}
     */
    validationRules() {
        return {
            name: {
                type: 'string',
                presence: true,
                length: {
                    minimum: 2,
                    maximum: 255,
                },
            },

            status: {
                type: 'string',
            },
            locked: {
                type: 'boolean',
            },
            isSystem: {
                type: 'boolean',
            },
            parentPlaybookUuid: {
                type: 'string',
            },
            workspaceTypeUuid: {
                type: 'string',
            },
            organizationUuid: {
                type: 'string',
            },
            createdByOrganizationMemberUuid: {
                type: 'string',
            },
            updatedByOrganizationMemberUuid: {
                type: 'string',
            },
        }
    }

    apiPaths() {
        return {
            ...super.apiPaths(),
            'replace': Engine.apiUrl(this.appResourceApiPrefix() + '/replace'),
            'usedByResources': Engine.apiUrl(this.appResourceApiPrefix() + '/replace/used-by-resources'),
        };
    }

    async replacePlaybook(data = {}) {
        return await this.enginePost(this.apiPaths()['replace'], data);
    }

    async isUsedByOtherResources(data = {}) {
        return await this.enginePost(this.apiPaths()['usedByResources'], data);
    }
}

export default PlaybookAppResource
